import { CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ITableKey } from 'src/app/modules/shared/components/basic-table/basic-table.constants';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { EPipeKeys } from '../../pages/policy-detail/policy-detail.constants';
import { CommonUtils } from 'src/app/utils/CommonUtils';

@Component({
  selector: 'app-policy-table',
  templateUrl: './policy-table.component.html',
  styleUrl: './policy-table.component.scss',
})
export class PolicyTableComponent {

  @Input() list: any[] = [];
  @Input() keys: IObjectKey[] = [];

  constructor(
    private _currencyPipe: CurrencyPipe
  ) { }

  getValue(item: ITableKey , key: IObjectKey): any {
    return CommonUtils.getValueByPath(item, key);
  }

}
